import IconSMS from "src/assets/images/common/icon-sms.png";
import IconWA from "src/assets/images/common/icon-whatsapp.png";

export const NON_ELIGILBE_BUSINESS_FORM = ["pjp", "bmt", "bpr", "bprs", "bank"];
export const NON_ELIGILBE_INDUSTRIES = [
  24, //Bankig
  25, //PPOB
  26, //Insurance & InsurTech
  27, //Payment/Payment Gateway/Remittance
  28, //SME Lending
  29, //Capital Market
  30, //Crypto Exchange
  31, //Koperasi Simpan Pinjam
  32 // Koperasi Simpan Pinjam Syariah
];

export const OTP_TYPE = {
  EMAIL: "email",
  PHONE_NUMBER: "phone_number",
  PHONE_NUMBER_WA: "phone_number_wa",
  COMPANY_PHONE_NUMBER: "company_number",
  COMPANY_PHONE_NUMBER_WA: "company_number_wa"
};

export const CHANNEL_OTP = {
  SMS: "sms",
  WA: "wa"
};

export const CHANNEL_OTP_CONTENT = {
  [CHANNEL_OTP.SMS]: { label: "SMS", icon: IconSMS },
  [CHANNEL_OTP.WA]: { label: "Whatsapp", icon: IconWA }
};

export const OTP_METHOD = {
  USER_PHONE_NUMBER: 1,
  USER_PHONE_NUMBER_WA: 3
};

export const MODAL_VIEWS_FORGET_PASSWORD = {
  INPUT_EMAIL: "input-email",
  SEND_OTP: "send-otp",
  VERIFY_OTP: "verify-otp",
  RESET_EMAIL_SENT: "reset-email-sent"
};

export const MODAL_VIEWS_CREATE_PASSWORD = {
  SEND_OTP: "send-otp",
  VERIFY_OTP: "verify-otp",
  CREATE_PASSWORD_EMAIL_SENT: "create-email-sent"
};

export const ERROR_CODE = {
  EXCEEDED_OTP_LIMIT_ERROR_CODE: 1106,
  PHONE_NOT_FOUND: 1033,
  EXPIRED_VALID_OTP: 2057
};

export const VALID_OTP_LENGTH = 6;

export const COUNTDOWN_TIMER_KEY = {
  OTP_FORGOT_PASSWORD: "ffb-timer-otp-forgot-password",
  RESEND_LINK_RESET_PASSWORD: "ffb-timer-resend-link-reset-password",
  OTP_CREATE_PASSWORD: "ffb-timer-otp-create-password",
  RESEND_LINK_CREATE_PASSWORD: "ffb-timer-resend-link-create-password",
  OTP_DEVICE_VERIFY: "ffb-timer-otp-device-verify"
};

export const COUNTDOWN_TIMER_VALUE = {
  OTP: 60, // 60 (seconds)
  RESEND_LINK_RESET_PASSWORD: 120, // 120 (seconds)
  RESEND_LINK_CREATE_PASSWORD: 120 // 120 (seconds)
};
